import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/checkbox-items/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/checkbox-items/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/detached-triggers-controlled/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/detached-triggers-controlled/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/detached-triggers-full/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/detached-triggers-full/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/detached-triggers-simple/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/detached-triggers-simple/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/group-labels/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/group-labels/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/radio-items/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/radio-items/tailwind/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/submenu/css-modules/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/submenu/tailwind/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlockPreComputedContent"] */ "/opt/build/repo/docs/src/components/CodeBlock/CodeBlockPreComputedContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Demo"] */ "/opt/build/repo/docs/src/components/Demo/Demo.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Link.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/HeadingLink.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Kbd/Kbd.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/QuickNav/QuickNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferenceTable"] */ "/opt/build/repo/docs/src/components/ReferenceTable/ReferenceTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarkdownLink"] */ "/opt/build/repo/docs/src/components/Subtitle/MarkdownLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/components/Subtitle/Subtitle.css");
;
import(/* webpackMode: "eager", webpackExports: ["Root","Head","Body","Row","RowHeader","ColumnHeader","Cell"] */ "/opt/build/repo/docs/src/components/Table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypePropRef"] */ "/opt/build/repo/docs/src/components/TypePropRef/TypePropRef.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TypeRef"] */ "/opt/build/repo/docs/src/components/TypeRef/TypeRef.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/css/mdx-components.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/demo-data/theme/css-modules/theme.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/hero/css-modules/index.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/docs/src/app/(docs)/react/components/menu/demos/open-on-hover/css-modules/index.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TypeCode"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.4_@types+react@19.2.14_next@16.1.7_@babel+core@7_7044fa6b7ff6dd7fd87b970ef1a3d670/node_modules/@mui/internal-docs-infra/abstractCreateTypes/TypeCode.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["CodeHighlighterClient"] */ "/opt/build/repo/node_modules/.pnpm/@mui+internal-docs-infra@0.11.1-canary.4_@types+react@19.2.14_next@16.1.7_@babel+core@7_7044fa6b7ff6dd7fd87b970ef1a3d670/node_modules/@mui/internal-docs-infra/CodeHighlighter/CodeHighlighterClient.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.1.7_@babel+core@7.29.0_@playwright+test@1.59.1_babel-plugin-react-compiler@1.0._01582baedb0408169f7f427edd182fd3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MenuArrow"] */ "/opt/build/repo/packages/react/src/menu/arrow/MenuArrow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuBackdrop"] */ "/opt/build/repo/packages/react/src/menu/backdrop/MenuBackdrop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuCheckboxItemIndicator"] */ "/opt/build/repo/packages/react/src/menu/checkbox-item-indicator/MenuCheckboxItemIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuCheckboxItem"] */ "/opt/build/repo/packages/react/src/menu/checkbox-item/MenuCheckboxItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuGroupLabel"] */ "/opt/build/repo/packages/react/src/menu/group-label/MenuGroupLabel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuGroup"] */ "/opt/build/repo/packages/react/src/menu/group/MenuGroup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuItem"] */ "/opt/build/repo/packages/react/src/menu/item/MenuItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuLinkItem"] */ "/opt/build/repo/packages/react/src/menu/link-item/MenuLinkItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuPopup"] */ "/opt/build/repo/packages/react/src/menu/popup/MenuPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuPortal"] */ "/opt/build/repo/packages/react/src/menu/portal/MenuPortal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuPositioner"] */ "/opt/build/repo/packages/react/src/menu/positioner/MenuPositioner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuRadioGroup"] */ "/opt/build/repo/packages/react/src/menu/radio-group/MenuRadioGroup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuRadioItemIndicator"] */ "/opt/build/repo/packages/react/src/menu/radio-item-indicator/MenuRadioItemIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuRadioItem"] */ "/opt/build/repo/packages/react/src/menu/radio-item/MenuRadioItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuRoot"] */ "/opt/build/repo/packages/react/src/menu/root/MenuRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuSubmenuRoot"] */ "/opt/build/repo/packages/react/src/menu/submenu-root/MenuSubmenuRoot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuSubmenuTrigger"] */ "/opt/build/repo/packages/react/src/menu/submenu-trigger/MenuSubmenuTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuTrigger"] */ "/opt/build/repo/packages/react/src/menu/trigger/MenuTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuViewport"] */ "/opt/build/repo/packages/react/src/menu/viewport/MenuViewport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/opt/build/repo/packages/react/src/separator/Separator.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/react/src/utils/popups/popupStoreUtils.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/ReactStore.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/store/StoreInspector.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/utils/src/useRefWithInit.ts");
